import { Action, State, StateContext } from '@ngxs/store';

import { Transaction } from './transaction.model';
import * as TransactionActions from './transaction.actions';

@State<Transaction>({
  name: 'transaction',
  defaults: new Transaction()
})
export class TransactionState {
  @Action(TransactionActions.ShowValidation)
  addInfoItem(
    { getState, setState }: StateContext<Transaction>,
    {}: TransactionActions.ShowValidation
  ) {
    const state = getState();
    setState({ ...state, validation: true });
  }
  @Action(TransactionActions.SetTransaction)
  setTransaction(
    { getState, setState }: StateContext<Transaction>,
    { payload }: TransactionActions.SetTransaction
  ) {
    const state = getState();
    setState({ ...state, tran: payload });
  }
  @Action(TransactionActions.ShowError)
  showError(
    { getState, setState }: StateContext<Transaction>,
    { payload }: TransactionActions.ShowError
  ) {
    const state = getState();
    setState({ ...state, error: payload.error });
  }
}
